import React from 'react'
import PropTypes from 'prop-types'
import { Ok } from '../Icons'
import { Feature } from '../CarFeatures'

const Features = ({ features, display }) => features.map((feature, index) => <Feature
  key={`${index}-card-feature`}
  icon={<Ok color='accent_dark70' />}
  display={display}
  text={feature} />)

Features.defaultProp = {
    display: 'inline-flex',
}

Features.propTypes = {
    features: PropTypes.arrayOf(PropTypes.string),
    display: PropTypes.string,
}

export default Features
